export default "__VITE_ASSET__5a4b8c18__"